/**
 * @generated SignedSource<<abb5d3dddd5bf9628014ca9bc8211159>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FiltersForLanding$data = {
  readonly filtersOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersContent_navigationCustomisation">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersContent">;
  readonly " $fragmentType": "Nav4FiltersForLanding";
};
export type Nav4FiltersForLanding$key = {
  readonly " $data"?: Nav4FiltersForLanding$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersForLanding">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityAriFilters"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipOrderQuery"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4FiltersForLanding",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Nav4FiltersContent"
    },
    {
      "condition": "skipOrderQuery",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "filtersOrder",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "entityAriFilters"
            },
            {
              "kind": "Variable",
              "name": "ownerAri",
              "variableName": "ownerAri"
            }
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Nav4FiltersContent_navigationCustomisation"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "76768f5ef86f410a026b69a8406deb64";

export default node;
